import React, { useRef, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

import styles from './styles.module.css';
import logo from './../../assets/images/logo-dark-small.png';

import api from '../../service/api';
import { removeAuthData } from '../../service/auth';

const SignUp = () => {
    var userEmpty = {
        name: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        agree: false
    };

    const toast = useRef(null);
    const history = useHistory();

    const [ loading, setLoading ] = useState(false);
    const [ created, setCreated ] = useState(false);
    const [ invalid, setInvalid ] = useState(false);
    const [ user, setUser] = useState(userEmpty);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _user = { ...user };
        _user[`${name}`] = val;

        setUser(_user);
    }

    const handleSignUp = () => {
        if(!user.name || !user.phone || !user.password
            || !user.confirmPassword || !user.agree){
            toast.current.show({severity:'warn', summary: 'Atenção',
                detail:'Preecha todos os campo para continuar!', life: 6000});
            return setInvalid(true);
        }


        if(user.password !== user.confirmPassword){
            setInvalid(true);
            return toast.current.show({severity:'error', summary: 'Atenção',
                detail:'As senhas não conferem. Verifique e tente novamente!', life: 6000});
        }

        setLoading(true);
        api().post("/users/create", {...user}).then(response => {
            if(response.status == 200 && response.data.result){
                setCreated(true);
            } else
                toast.current.show({severity:'error', summary: 'Atenção',
                    detail: response.data.message, life: 6000});

            setLoading(false);
        }).catch((error, response) => {
            setLoading(false);
            if(response && response.data && response.data.message)
                toast.current.show({severity:'error', summary: 'Atenção',
                    detail: response.data.message, life: 6000});
            else toast.current.show({severity:'error', summary: 'Atenção',
            detail: "Não foi possível registra a sua conta!", life: 6000});
        });
    }

    const header = () => {
        return(
            <div className={styles.contentHeader}>
                <img style={{ width: '70%', maxWidth: '300px' }} src={logo} alt="Logo da Ctruck" />
            </div>
        )
    }

    const CreatedCard =  () => (
        <Card header={header} className={styles.myCard}>
            <h3 className="p-success" style={{ textAlign: 'center', color: '#188A42' }}>
                <strong>O seu cadastro foi realizado com sucesso!</strong>
            </h3>
            <p>É um prazer ter você com nós.
                Fique a disposição para entrar em contato com nós nos nossos meios de atendimento. Muito obrigado</p>
            <div style={{ textAlign: 'center' }}>
                <Button label="Entrar agora" className="p-button-rounded" onClick={() => history.push("/")} />
            </div>
        </Card>
    );

    useEffect(function(){
        removeAuthData();
    }, []);

    return (
        <div className={styles.container}>
            <Toast ref={toast} position="top-right" />
            {!created ? <Card header={header} className={styles.myCard}>
                <div className={styles.contentForm}>
                    <div>
                        <Link to='/'>Possui cadastro? Acesse sua conta aqui</Link>
                    </div>
                    <div className="formgrid grid">
                        <div className="field col-12">
                            <label htmlFor="nome" className="block p-invalid">Nome</label>
                            <span className={styles.w100}>
                                <InputText className={"block" + (invalid && !user.name ? " p-invalid" : "")} id="nome"
                                    value={user.name}
                                    onChange={e => onInputChange(e, 'name')}
                                    disabled={loading}
                                    placeholder="Informe seu nome" />
                            </span>
                            {invalid && !user.name && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field xl:col-6 col-12">
                            <label htmlFor="telefone" className="block">WhatsApp</label>
                            <span className={styles.w100}>
                                <InputMask inputMode="number" id="telefone" mask="(99) 99999 - 9999"
                                    disabled={loading}
                                    value={user.phone}
                                    className={invalid && !user.phone ? " p-invalid" : ""}
                                    onChange={e => onInputChange(e, 'phone')}
                                    placeholder="Informe seu número de telefone" />
                            </span>
                            {invalid && !user.phone && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                        </div>
                        <div className="field xl:col-6 col-12">
                            <label htmlFor="email" className="block">E-mail</label>
                            <span className={ styles.w100}>
                                <InputText id="email" type="email" disabled={loading}
                                    className={invalid && !user.email ? " p-invalid" : ""}
                                    value={user.email}
                                    onChange={e => onInputChange(e, 'email')}
                                    placeholder="Informe seu e-mail" />
                            </span>
                            {invalid && !user.email && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                        </div>

                    </div>

                    <div className="formgrid grid">
                        <div className="field xl:col-6 col-12">
                            <label htmlFor="password" className="block">Senha</label>
                                <Password id="password"
                                    className={styles.w100 + (invalid && !user.password ? " p-invalid" : "")}
                                    disabled={loading}
                                    value={user.password}
                                    weakLabel='Fraca'
                                    mediumLabel='Média'
                                    strongLabel='Forte'
                                    promptLabel='Sua senha'
                                    onChange={e => onInputChange(e, 'password')}
                                    toggleMask
                                    placeholder="Informe sua senha"/>
                            {invalid && (!user.password || (user.password !== user.confirmPassword)) && <small className="p-invalid p-error">As senhas não conferem</small>}
                        </div>

                        <div className="field xl:col-6 col-12">
                            <label htmlFor="passwordConfirm" className="block">Confirmação </label>
                                <Password id="passwordConfirm"
                                    className={styles.w100 + (invalid && !user.confirmPassword ? " p-invalid" : "")} disabled={loading}
                                    toggleMask feedback={false}
                                    value={user.confirmPassword}
                                    onChange={e => onInputChange(e, 'confirmPassword')}
                                    placeholder="Confirme sua senha" />
                            {invalid && (!user.confirmPassword || (user.password !== user.confirmPassword)) && <small className="p-invalid p-error">As senhas não conferem</small>}
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col-1">
                            <Checkbox inputId="cb1" checked={user.agree} onChange={e => {
                                if(e && e.checked) onInputChange({ target: { value: true }}, 'agree');
                                else onInputChange({ value: false }, 'agree');

                            }} className={invalid && !user.agree ? "p-invalid" : ""} disabled={loading} />
                        </div>
                        <div className="field col-11">
                            <label htmlFor="cb1" style={{ marginBottom: 3 }} className="p-checkbox-label">
                                <Link target="_blank" to="/terms">Eu estou de acordo com os termos de uso e a politica de privacidade</Link>
                                {invalid && (!user.agree) && <small className="p-invalid p-error"><br /><br />É necessário aceitar os termos para cadastrar a sua conta</small>}
                            </label>
                        </div>
                    </div>


                    <div className={styles.buttonForm}>
                        <Button loading={loading} label={loading ? "Aguarde..." : "Cadastrar"}
                            onClick={handleSignUp}
                            className="p-button-rounded" />
                    </div>

                </div>
            </Card> : <CreatedCard />}

        </div>


    );
}

export default SignUp;
